import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../components/Logo";
import { CommonDataContext } from "contexts/CommonDataContext/CommonDataContext";
import { useTranslation } from "react-i18next"; 

function Footer() {

  const context = useContext(CommonDataContext);
  const { t } = useTranslation();
  const countryList = context?.countries;
  const location = useLocation();
  const isContactPage = location.pathname === "/contact-us";
  
  return (
    <footer className={isContactPage ? "contact-footer" : ""}>
      <div className="footer-wrapper">
        <div className="footer-details">
        <div className="footer-first">
            {/* <Logo className="font-primary" /> */}
            <img
              src="/images/webp/web-about.webp"
              className="img-fluid"
              alt=""
            />
            <div className="copy-right mt-3">
             
              <h6 className="lh-base">{t("footer:description","This tool is deploed by the Council of Europe under the European Union/Council of Europe Joint Programme")}{" "}
                "<Link to="/">{t("footer:roma-title","Roma Integration III")}</Link>"
              </h6>
            </div>
            <div className="social-group">
              <Link to="/" target="_blank">
                <img src="/images/svg/facebook.svg" alt="" />
              </Link>
              <Link to="/" target="_blank">
                <img src="/images/svg/twitter.svg" alt="" />
              </Link>
              <Link to="/" target="_blank">
                <img src="/images/svg/instagram.svg" alt="" />
              </Link>
              <Link to="/" target="_blank">
                <img src="/images/svg/linkedin.svg" alt="" />
              </Link>
            </div>
          </div>
          <div>
            <h4>{t("header-nav:beneficiary","Beneficiary")}</h4>
            <ul className="page-list">
              {countryList?.map(country => <li>
                <Link key={country.id} to={`/country/${country?.name}`}>{country?.name}</Link>
              </li>)}
              {/* <li>
                <Link to="/country/bosnia">Bosnia and Herzegovina</Link>
              </li>
              <li>
                <Link to="/country/kosovo">Kosovo</Link>
              </li>
              <li>
                <Link to="/country/montenegro">Montenegro</Link>
              </li>
              <li>
                <Link to="/country/macedonia">North Macedonia</Link>
              </li>
              <li>
                <Link to="/country/serbia">Serbia</Link>
              </li> */}
            </ul> 
          </div>
          <div>
           
            <h4>{t("footer:links","Links")}</h4>
            <ul className="page-list">
              <li>
                <Link to="/">{t("header-nav:home","Home")}</Link>
              </li>
              <li>
                <Link to="/legislation">{t("header-nav:legislation","Legislation")}</Link>
              </li>
              <li>
                <Link to="/contact-us">{t("header-nav:contact-us","Contact Us")}</Link>
              </li>
            </ul>
          </div>
          <div>
            <h4>{t("header-nav:contact-us","Contact Us")}</h4>
            <ul className="contact-list">
            
              <li>
                <img src="/images/svg/mail.svg" alt="" />
                roma.team@coe.int
              </li>
            </ul>
          </div>
        </div>
        <div className="sub-footer">
          <div className="copy-right">
            <h6>
              {t("footer:copyright-text","© Copyright 2024 ROMA INTEGRATION. All Rights Reserved by")}{" "}
             
              <Link to="/">{t("footer:roma-integration","ROMA INTEGRATION")}</Link>
            </h6>
          </div>
          <ul className="page-list">
            <li>
            
              <Link to="/privacy-policy">{t("footer:privacy-policy","Privacy Policy")}</Link>
            </li>
            <li>
           
              <Link to="/cookies-policy">{t("footer:cookies-policy","Cookies Policy")}</Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
